// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Link from 'next/link';

// lib files
import { PBS_SHOP_URL } from '@/lib/constants';
import { sendPbsGtmEvent } from '@/lib/helpers/send-pbs-gtm-event';

// components
import LinkButton from '@/components/Button/LinkButton';

// svgs
import ShopIcon from '@/public/svg/pbs-shop.svg';

// styles
import styles from './ShopMenuItem.module.scss';

interface ShopMenuItemProps {
  className?: string;
}

const ShopMenuItem = (props: ShopMenuItemProps) => {
  const { className } = props;

  return (
    <li className={`${className ? className : ''} ${styles.shop_menu_item}`} data-sentry-component="ShopMenuItem" data-sentry-source-file="ShopMenuItem.tsx">
      <Link
        href={PBS_SHOP_URL}
        className={styles.shop_link}
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          sendPbsGtmEvent({
            feature_category: "utility nav shop link",
            feature_name: "utility nav shop link",
            object_name: "utility nav shop link",
            object_text: "Shop",
            object_type: "link",
            object_action: "click",
            object_action_behavior: "send user to pbs shop url",
            object_url: PBS_SHOP_URL,
        })}}
      data-sentry-element="Link" data-sentry-source-file="ShopMenuItem.tsx">
        <ShopIcon className={styles.shop_icon} data-sentry-element="ShopIcon" data-sentry-source-file="ShopMenuItem.tsx" /> Shop
      </Link>

      <div className={styles.shop_menu}>
        <div className={styles.shop_menu_inner}>
          <p>Visit the official PBS Shop for t-shirts, tote bags, and more. Every purchase supports PBS.</p>
          <LinkButton
            href={PBS_SHOP_URL}
            className={styles.shop_menu_button}
            target="_blank"
            onClick={() => {
              sendPbsGtmEvent({
                feature_category: "utility nav shop drop down link",
                feature_name: "utility nav shop drop down link",
                object_name: "utility nav shop drop down link",
                object_text: "Shop Now",
                object_type: "link",
                object_action: "click",
                object_action_behavior: "send user to pbs shop url",
                object_url: PBS_SHOP_URL,
            })}}
          data-sentry-element="LinkButton" data-sentry-source-file="ShopMenuItem.tsx">
            Shop Now
          </LinkButton>
        </div>
      </div>
    </li>
  );
};

export default ShopMenuItem;
